import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import SearchIcon from "@mui/icons-material/Search";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import ChatIcon from "@mui/icons-material/Chat";
import EmailIcon from "@mui/icons-material/Email";
import { fetchData } from "../../services/BackendServices";
import { useLoading } from "../../context/LoadingContext";
import { Auth } from "aws-amplify";
import { jwtDecode } from "jwt-decode";
import { getParameterFromManager } from "../../services/Utils";
import ChatbotWidget from "../../components/ChatbotWidget";
const GPDashboard = () => {
  const navigate = useNavigate();
  const { setLoading } = useLoading();
  const [userKybInfo, setUserKybInfo] = useState(null);
  const [isKybLoading, setIsKybLoading] = useState(true);
  const [activeUser, setActiveUser] = useState("");
  const [INRToUsd, setINRToUSD] = useState(0.012);
  // 🔹 Redirection Handlers
  const handleViewOffers = () => navigate("/global-partner/discoverevaluate");
  const handleRaisedRFQs = () => navigate("/global-partner/rfqoffers");
  const handleProduct = () => navigate("/global-partner/discoverevaluate");
  const handleExploreFinancing = () =>
    navigate("/global-partner/finance/rfqoffers");
  const handleStartVerification = () => navigate("/global-partner/setting");

  // 🔹 External Communication Links
  const handleWhatsAppClick = () =>
    window.open("https://wa.me/9836236245", "_blank"); // Replace number
  const handleEmailClick = () => navigate("/global-partner/support");
  const handleChatClick = () => navigate("/global-partner/messaging");
  useEffect(() => {
    const checkUser = async () => {
      try {
        const user = await Auth.currentAuthenticatedUser();
        const token = user.signInUserSession.idToken.jwtToken;
        const decodedToken = jwtDecode(token);

        const groups = decodedToken["cognito:groups"] || [];
        if (!groups.includes("AMTPL_GLOBAL_PARTNERS")) {
          await Auth.signOut();
          navigate("/global-partner");
        } else {
          setActiveUser(user.attributes.email);
        }

        let inrToUsdVal = await getParameterFromManager("INR_TO_USD");
        inrToUsdVal = parseFloat(inrToUsdVal);
        setINRToUSD(inrToUsdVal);
      } catch (error) {
        await Auth.signOut();
        navigate("/");
      }
    };

    checkUser();
  }, [navigate]);

  useEffect(() => {
    const checkUserKYB = async () => {
      if (!activeUser) return; // Wait until activeUser is available
      setLoading(true);
      setIsKybLoading(true);
      try {
        const userKYBResponse = await fetchData({
          target: "listUserKYB",
          userOrder: "UserKybID",
          orderDirection: "ASC",
          rowStart: 0,
          pageSize: 1,
          filterTerms: { EmailID: activeUser },
        });

        console.log("userKYBResponse", userKYBResponse.items);

        if (userKYBResponse.items && userKYBResponse.items.length > 0) {
          setUserKybInfo(userKYBResponse.items[0]);
        } else {
          setUserKybInfo(null);
        }
      } catch (error) {
        console.error("Error fetching KYB info:", error);
        setUserKybInfo(null);
      } finally {
        setLoading(false);
        setIsKybLoading(false);
      }
    };

    checkUserKYB();
  }, [activeUser, setLoading]);

  return (
    <>
      <ChatbotWidget userType="global-partner" />
      <div className="container-GP p-4 bg-white shadow-sm">
        <div
          className="text-center p-3 mb-4 rounded-top"
          style={{
            backgroundColor: "rgb(222 107 20)",
            color: "white",
            fontWeight: "700",
          }}
        >
          <h2 style={{ fontWeight: "700" }}>Welcome to Grains Global!</h2>
        </div>

        <div className="input-group mb-4">
          <input
            type="text"
            className="form-control"
            placeholder="Search for grains, suppliers, or deals..."
          />
          <button className="btn-search" type="button">
            <SearchIcon />
          </button>
        </div>

        <div className="row">
          {/* Sell Offers */}
          <div className="col-md-4 mb-4">
            <div className="card h-150 card-dash-css">
              <div
                className="card-body"
                style={{ lineHeight: "30px", padding: "0 !important" }}
              >
                <h5
                  className="card-title"
                  style={{ fontWeight: "700", color: "#000" }}
                >
                  Do you want to sell?
                </h5>
                <p className="card-text card-text-height">
                  Showcase your best grains to a global network of verified
                  buyers.
                </p>
                <div className="text-center">
                  <button className="submit-btn-100" onClick={handleViewOffers}>
                    Create Offer
                  </button>
                </div>
              </div>
            </div>
          </div>

          {/* Buy - RFQs */}
          <div className="col-md-4 mb-4">
            <div className="card h-150 card-dash-css">
              <div
                className="card-body"
                style={{ lineHeight: "30px", padding: "0 !important" }}
              >
                <h5
                  className="card-title"
                  style={{ fontWeight: "700", color: "#000" }}
                >
                  Do you want to buy?
                </h5>
                <p className="card-text card-text-height">
                  Streamline your supplier communication with smart RFQs
                </p>
                <div className="display-flex-dash">
                  <button className="submit-btn-100" onClick={handleViewOffers}>
                    View Offers
                  </button>
                  <button className="submit-btn-100" onClick={handleRaisedRFQs}>
                    Create RFQ
                  </button>
                </div>
              </div>
            </div>
          </div>

          {/* Hot Deals */}
          <div className="col-md-4 mb-4">
            <div className="card h-150 card-dash-css">
              <div
                className="card-body"
                style={{ lineHeight: "30px", padding: "0 !important" }}
              >
                <h5
                  className="card-title"
                  style={{ fontWeight: "700", color: "#000" }}
                >
                  Unlock verified global opportunities
                </h5>
                <p className="card-text card-text-height">
                  Browse trusted listings and discover profitable import–export
                  opportunities from verified partners.
                </p>
                <div className="text-center">
                  <button className="submit-btn-100" onClick={handleProduct}>
                    Explore Deal
                  </button>
                </div>
              </div>
            </div>
          </div>

          {/* Trade Finance */}
          <div className="col-md-4 mb-4">
            <div className="card h-150 card-dash-css">
              <div
                className="card-body"
                style={{ lineHeight: "30px", padding: "0 !important" }}
              >
                <h5
                  className="card-title"
                  style={{ fontWeight: "700", color: "#000" }}
                >
                  Do you want to finance your import?
                </h5>
                <p className="card-text card-text-height">
                  Secure funding for your purchases and sales to maximize trade
                  capacity.
                </p>
                <div className="text-center">
                  <button
                    className="submit-btn-100"
                    onClick={handleExploreFinancing}
                  >
                    Create RFQ
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div className="col-md-4 mb-4">
            <div className="card h-150 card-dash-css">
              <div
                className="card-body"
                style={{ lineHeight: "30px", padding: "0 !important" }}
              >
                <h5
                  className="card-title"
                  style={{ fontWeight: "700", color: "#000" }}
                >
                  Do you want to finance your export?
                </h5>
                <p className="card-text card-text-height">
                  Secure funding for your purchases and sales to maximize trade
                  capacity.
                </p>
                <div className="text-center">
                  <button
                    className="submit-btn-100"
                    onClick={handleExploreFinancing}
                  >
                    Create RFQ
                  </button>
                </div>
              </div>
            </div>
          </div>

          {/* KYB */}
          <div className="col-md-4 mb-4">
            <div className="card h-150 card-dash-css">
              <div
                className="card-body"
                style={{ lineHeight: "30px", padding: "0 !important" }}
              >
                {/* ---------- STATUS TITLE ---------- */}
                {isKybLoading ? null : (
                  <h5
                    className="card-title"
                    style={{ fontWeight: "700", color: "#000" }}
                  >
                    Your KYB Status:{" "}
                    {(() => {
                      const s = userKybInfo?.Status;

                      // In Review (blank/empty)
                      if (!s || s === "") {
                        return <span className="status-color">Pending</span>;
                      }
                      // Pending
                      if (s === "Pending") {
                        return <span className="status-color"> In Review</span>;
                      }
                      // Approved
                      if (s === "Approved") {
                        return (
                          <span
                            style={{
                              color: "green",
                              fontWeight: "700",
                              fontSize: "15px",
                            }}
                          >
                            Approved
                          </span>
                        );
                      }
                      // Rejected (or any other value)
                      return <span className="status-color">Rejected</span>;
                    })()}
                  </h5>
                )}

                {/* ---------- DESCRIPTION ---------- */}
                <p className="card-text card-text-height">
                  {isKybLoading ? (
                    <span>Loading...</span>
                  ) : userKybInfo?.Status === "Approved" ? (
                    <>Trade Confidently with Grains Global</>
                  ) : (
                    <>Ensure security and unlock full platform features.</>
                  )}
                </p>

                {/* ---------- BUTTON ---------- */}
                {isKybLoading
                  ? null
                  : (() => {
                      const s = userKybInfo?.Status;

                      // In Review → Not Verified
                      if (!s || s === "") {
                        return (
                          <div className="text-center">
                            <button
                              className="submit-btn-100"
                              onClick={handleStartVerification}
                            >
                              Start verification
                            </button>
                          </div>
                        );
                      }

                      // Pending → Start verification
                      if (s === "Pending") {
                        return (
                          <div className="text-center">
                            <button className="submit-btn-100">
                              Not verification
                            </button>
                          </div>
                        );
                      }

                      // Rejected → Please contact Admin
                      if (s === "Rejected") {
                        return (
                          <div className="text-center">
                            <button className="submit-btn-100">Rejected</button>
                          </div>
                        );
                      }

                      // Approved → Verified (disabled)
                      return (
                        <div className="text-center">
                          <button disabled className="submit-btn-100">
                            Verified
                          </button>
                        </div>
                      );
                    })()}
              </div>
            </div>
          </div>

          {/* Contact Support */}
          <div className="col-md-4 mb-4">
            <div className="card h-150 card-dash-css">
              <div
                className="card-body"
                style={{ lineHeight: "30px", padding: "0 !important" }}
              >
                <h5
                  className="card-title"
                  style={{ fontWeight: "700", color: "#000" }}
                >
                  Contact Support
                </h5>
                <div
                  className="dash-icon card-text-height display-flex-dash"
                  style={{ gap: "40px" }}
                >
                  <div
                    onClick={handleWhatsAppClick}
                    className="whats-css"
                    style={{ cursor: "pointer" }}
                  >
                    <WhatsAppIcon />
                  </div>
                  <div
                    onClick={handleEmailClick}
                    className="email-css"
                    style={{ cursor: "pointer" }}
                  >
                    <EmailIcon />
                  </div>
                  <div
                    onClick={handleChatClick}
                    className="chat-css"
                    style={{ cursor: "pointer" }}
                  >
                    <ChatIcon />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default GPDashboard;
